import { gql } from '@apollo/client';

export * from './escrowMemberCreate.mutation.generated';

export const ESCROW_MEMBER_CREATE = gql`
  mutation escrowMemberCreate($input: EscrowMemberCreateInput!) {
    escrowMemberCreate(input: $input) {
      errors
      success
      escrowMember {
        ...EscrowMemberFragment
      }
    }
  }
`;
